import * as React from 'react'
import cn from 'classnames'

import styles from './testimonal.module.scss'

interface ITestimonalProps {
  imgSrc: string
  name: React.ReactNode
  text: React.ReactNode
  jobTitle: React.ReactNode
  variant?: 'brand' | 'free' | 'large'
}
const Testimonal = ({ imgSrc, name, text, jobTitle, variant = 'brand' }: ITestimonalProps) =>
  variant !== 'large' ? (
    <div className={styles.root}>
      <span className={cn(styles.quote, variant === 'free' && styles.free)}>{'”'}</span>
      <div>
        <p className={styles.text}>{text}</p>
        <p className={styles.name}>
          {name}
          {', '}
          {jobTitle}
        </p>
      </div>
      <img alt="Person" className={styles.image} src={imgSrc} />
    </div>
  ) : (
    <div className={`${styles.root} ${styles.large}`}>
      <img alt="Person" className={styles.image} src={imgSrc} />
      <p className={styles.name}>{name}</p>
      <p className={styles.jobTitle}>{jobTitle}</p>
      <p className={styles.text}>{text}</p>
    </div>
  )

export default Testimonal
